import i18n from 'i18next'
import { reactI18nextModule } from 'react-i18next'

const locales = {
    'en': 'en',
    'es': 'es-ES',
    'de': 'de',
    'fr': 'fr',
    'pt_br': 'pt-BR',
    'it': 'it',
    'ja': 'ja',
    'ru': 'ru',
}

const namespaces = {
    'global': 'global',
    'imageProofing': 'image-proofing',
    'videoProofing': 'video-proofing',
    'documentProofing': 'document-proofing',
    'boards': 'boards',
    'report': 'report',
    'gantt': 'gantt-chart',
    'customWorkflow': 'custom-workflow',
    'requestForms' : 'request-forms',
    'calendar' : 'calendar',
}

function deepObjectExtend (target, source) {
    for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
            if (target[prop] && typeof source[prop] === 'object') {
                deepObjectExtend(target[prop], source[prop]);
            }
            else {
                target[prop] = source[prop];
            }
        }
    }
    return target;
}

const getPageResources = () => {
    if(window.interactiveScreeshotOptions && window.interactiveScreeshotOptions.resources) {
        return window.interactiveScreeshotOptions.resources
    }

    return {}
}

const locale = (
    (window.interactiveScreeshotOptions &&
        window.interactiveScreeshotOptions.locale) ||
    (window.wrike && window.wrike.locale) ||
    'en'
).replace(/-/gi, '_')

const resources = {}

const localeKeys = Object.keys(locales)
const namespaceKeys = Object.keys(namespaces)
let localeKey;
let namespaceKey;

for(let i = 0; i < localeKeys.length; i++) {
    localeKey = localeKeys[i]
    resources[localeKey] = {}
    for(let j = 0; j < namespaceKeys.length; j++) {
        namespaceKey = namespaceKeys[j]
        try {
            resources[localeKey][namespaceKey] = require(`./${locales[localeKey]}/${namespaces[namespaceKey]}.json`)
        } catch (ex) {
            console.error('no localization file present: ')
        }
    }
}

i18n
    .use(reactI18nextModule)
    .init({
        fallbackLng: 'en',
        lng: locale,
        debug: process.env.NODE_ENV === 'development',
        defaultNS: 'global',
        resources: deepObjectExtend(resources, getPageResources()),

        interpolation: {
            escapeValue: false,
        },

        react: {
            wait: false,
            bindI18n: 'languageChanged loaded',
            bindStore: false,
            nsMode: 'default'
        }
    })

export default i18n